import React from 'react'

export default ({ className }) => {
  return (
    <svg className={className} viewBox='0 0 9 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.50004 0H8.00004V3.14394H1.308C1.524 2.88794 1.756 2.50394 2.004 1.99194H1.584C1.08 2.57594 0.552 3.00794 0 3.28794V3.50394C0.552 3.77594 1.08 4.20794 1.584 4.79994H2.004C1.756 4.28794 1.524 3.90394 1.308 3.64794H8.50004V3.5V3.14394V0Z' fill='currentColor' />
    </svg>
  )
}
